import wmdeck from '../assets/wmdeck.jpg'

export default function Economics() {
  return (
    <div className="container">   
      <div className="page">
    
        <h2 className='align_center'>      
            Wave Mill Economics
        </h2>
    

        <p className="align_left">
            The table below compares the cost and performance of a 2 MW diesel generator operating 24/7 at half load with a 2 MW Wave Mill located in an area with an average wave input of 40 kW/m. 
            The Wave Mill payback period is estimated at two years. <br />
            <br />
            Note: This is an example based on a proportional comparison of expenditures related to the construction, deployment, and operation of a 2 MW Wave Mill unit, and the operating costs of a 2 MW diesel generator. <br />
            <br />
            To provide an accurate quote, we require the mooring location, power demand, and other relevant technical details from the customer. <br /> 
        </p> 

        <table  className='display_data'>
        <tr valign="top" style={{textAlign:'center', fontWeight: 'bold'}}>
            <th></th>
            <th>2MW Diesel  0.8 Load</th>
            <th>2MW WEC</th>
        </tr>
        <tr>
            <td>CAPEX($)</td>
            <td align="right">2,000,000</td>
            <td align="right">8,000,000</td>
        </tr>
        <tr>
            <td align="left">OPEX,2% of CAPEX($) </td>
            <td align="right">40,000</td>
            <td align="right">160,000</td>
        </tr>
        <tr>
            <td align="left">Wave parameters for WEC</td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td align="left">Height (m) /Length (m)/Period (sec)</td>
            <td></td>
            <td align="right">3.2/99/8</td>
        </tr>
        <tr>
            <td align="left">Velocity (m/s)</td>
            <td></td>
            <td align="right">12.5</td>
        </tr>
        <tr>
            <td align="left">Power from 1 linear meter (kW/m)</td>
            <td></td>
            <td align="right">45</td>
        </tr>
        <tr>
            <td align="left">Efficiency from wave to wire (%) </td>
            <td></td>
            <td align="right">40</td>
        </tr>
        <tr>
            <td align="left">Fuel consumption (L-h)</td>
            <td align="right">300</td>
            <td></td>
        </tr>
        <tr>
            <td align="left">Annual fuel (L)</td>
            <td align="right">2,628,000</td>
            <td></td>
        </tr>
        <tr>
            <td align="left">Fuel price ($/L)</td>
            <td align="right">1.5</td>
            <td></td>
        </tr>
        <tr>
            <td align="left">Fuel annual ($)</td>
            <td align="right">3,942,000</td>
            <td></td>
        </tr>
        <tr>
            <td align="left">Power output (kW) (½ Load)</td>
            <td align="right">1,600</td>
            <td align="right">2,000</td>
        </tr>
        <tr>
            <td align="left">Annual power output kWh</td>
            <td align="right">14,016,000</td>
            <td align="right">17,520,000</td>
        </tr>
        <tr>
            <td align="left">Life-span (year)  </td>
            <td align="right"></td>
            <td align="right"></td>
        </tr>
        <tr>
            <td align="left">Operational time (year)</td>
            <td align="right">25</td>
            <td align="right">25</td>
        </tr>
        <tr>
            <td align="left">Cost of kW ($)</td>
            <td align="right">0.33</td>
            <td align="right">0.03</td>
        </tr>
        <tr>
            <td align="left">Total expenditure ($)</td>
            <td align="right">115,550,000</td>
            <td align="right">12,000,000</td>
        </tr>
        </table>  
        <img src={wmdeck} alt='' />
        </div>
    </div>
)}
